import { Note } from '@eigtech/notes-types'

export function sortNotesByDate(notes: Note[], isAscending?: boolean): Note[] {
  return [...notes].sort((a, b) =>
    sortNotes(
      a.createdOn ?? new Date().toISOString(),
      b.createdOn ?? new Date().toISOString(),
      isAscending ?? false
    )
  )
}

const sortNotes = (a: string, b: string, ascending: boolean) => {
  const dateA = new Date(a).getTime()
  const dateB = new Date(b).getTime()
  return ascending ? dateA - dateB : dateB - dateA
}
